<template>
  <NuxtLayout name="default">
    <div class="china_exh_list">
      <div class="choose_box">
        <SectionTitle
          :h1="true"
          :title="`${type === '1' ? $t('common.internation') : $t('common.china')}${$t('exhibition.industryTitle')}`"
          style="font-size: 18px" />
        <div class="filter_container">
          <div class="industry_filter filter">
            <div
              class="label"
              style="padding-top: 11px">
              {{ $t('exhibition.filters.keyword') }}
            </div>
            <div class="value_wrapper">
              <div class="search_count">
                <el-input
                  v-model="keyword"
                  :class="keywordError ? 'keyword-error' : ''"
                  :placeholder="keywordPlaceholder"
                  @input="handleKeywordInput"
                  @keyup.enter.native="handleSearch" />
                <el-button
                  class="search-btn"
                  icon="el-icon-search"
                  @click="handleSearch" />
              </div>
            </div>
          </div>
          <!-- 已选 -->
          <div
            v-if="checkTags.length > 0"
            class="industry_filter filter">
            <div class="label">
              {{ $t('exhibition.filters.selectedCondition') }}
            </div>
            <div class="value_wrapper">
              <nuxt-link
                v-for="tag in checkTags"
                :key="tag.name"
                :to="newUrl(tag)"
                prefetch-on="interaction">
                <el-tag
                  class="checked-tag"
                  closable
                  size="small">
                  {{ tag.name }}
                </el-tag>
              </nuxt-link>
            </div>
          </div>
          <!-- v-show="!firstIndustryId || !secondIndustryId" -->
          <div class="industry_filter filter">
            <div class="label">{{ $t('common.industry') }}</div>
            <div class="industry_checkbox value_wrapper">
              <!-- <a
                v-for="item in industry"
                :key="item.industryId"
                :title="item.industryName + $t('common.fair')"
                :href="`/exhibition-${item.industryId}-0-${area}-${province}-${city}-${date}-1/${isShowKeyword(keyword)}`">
                {{ item.industryName }}
              </a> -->
              <!-- <el-radio-group v-show="firstIndustryId === '0'">
                <nuxt-link
                  v-for="item in industry"
                  :key="item.industryId"
                  :title="item.industryName + $t('common.fair')"
                  :to="`/exhibition-${item.industryId}-0-${area}-${province}-${city}-${date}-1/${isShowKeyword(keyword)}`" prefetch-on="interaction">
                  <el-radio
                    :value="item.industryId"
                    style="margin: 0 24px 24px 0">
                    {{ item.industryName }}
                  </el-radio>
                </nuxt-link>
              </el-radio-group> -->
              <div v-show="firstIndustryId === '0'">
                <a
                  v-for="item in industry"
                  :key="item.industryId"
                  :title="item.industryName + $t('common.fair')"
                  class="item_a"
                  :href="`/exhibition-${item.industryId}-0-${area}-${province}-${city}-${date}-1/${isShowKeyword(keyword)}`">
                  {{ item.industryName }}
                </a>
              </div>

              <!-- <el-radio-group
                v-show="firstIndustryId"
                v-model="secondIndustryId">
                <nuxt-link
                  v-for="item in secondIndustry"
                  :key="item.id"
                  :title="item.industryName + $t('common.fair')"
                  :to="`/exhibition-${item.pid}-${item.id}-${area}-${province}-${city}-${date}-1/${isShowKeyword(keyword)}`" prefetch-on="interaction">
                  <el-radio
                    :value="String(item.id)"
                    style="margin: 0 24px 24px 0">
                    {{ item.industryName }}
                  </el-radio>
                </nuxt-link>
              </el-radio-group> -->
              <div v-show="firstIndustryId">
                <a
                  v-for="item in secondIndustry"
                  :key="item.id"
                  class="item_a"
                  :class="item.id == secondIndustryId ? 'active' : ''"
                  :title="item.industryName + $t('common.fair')"
                  :href="`/exhibition-${item.pid}-${item.id}-${area}-${province}-${city}-${date}-1/${isShowKeyword(keyword)}`">
                  {{ item.industryName }}
                </a>
              </div>
            </div>
          </div>
          <!-- 展会时间 -->
          <!-- v-show="date === '0'" -->
          <div class="date_filter filter">
            <div class="label">{{ $t('exhibition.time') }}</div>
            <div class="date_checkbox value_wrapper">
              <a
                :title="$t('common.fair')"
                class="item_a"
                :class="date == '0' ? 'active' : ''"
                :href="`/exhibition-${firstIndustryId}-${secondIndustryId}-${area}-${province}-${city}-0-1/${isShowKeyword(keyword)}`">
                {{ $t('exhibition.filters.all') }}
              </a>
              <a
                v-for="item in dates"
                :key="item.value"
                :title="item.label + '展会'"
                class="item_a time_item"
                :class="[!item.hasData ? 'disable' : '', date === item.value ? 'active' : '']"
                :href="
                  item.hasData
                    ? `/exhibition-${firstIndustryId}-${secondIndustryId}-${area}-${province}-${city}-${item.value}-1/${isShowKeyword(keyword)}`
                    : 'javascript:void(0)'
                "
                rel="nofollow noindex">
                {{ item.label }}
              </a>
              <ClientOnly>
                <a
                  href="javascript:void(0)"
                  rel="nofollow noindex"
                  class="more-btn"
                  style="margin-bottom: 27px"
                  @click="handleDateMore">
                  {{ moreDate ? $t('exhibition.filters.packUp') : $t('exhibition.filters.more') }}
                  <el-icon>
                    <ArrowUp v-show="moreDate"></ArrowUp>
                    <ArrowDown v-show="!moreDate"></ArrowDown>
                  </el-icon>
                </a>
              </ClientOnly>
            </div>
          </div>
          <div class="area_filter filter">
            <div class="label">{{ $t('exhibition.filters.area') }}</div>
            <div class="area_checkbox value_wrapper">
              <a
                :title="$t('common.fair')"
                class="item_a"
                :class="type == '9999' ? 'active' : ''"
                href="javascript:void(0)"
                @click="toAllCity">
                {{ $t('exhibition.filters.all') }}
              </a>
              <a
                v-for="item in typeList"
                :key="item.value"
                :title="$t(item.langKey) "
                class="item_a"
                :class="type == item.value ? 'active' : ''"
                :href="
                  item.key === 'international'
                    ? `/exhibition-${firstIndustryId}-${secondIndustryId}-0-0-0-${date}-1/${isShowKeyword(keyword)}`
                    : `/exhibition-${firstIndustryId}-${secondIndustryId}-1-0-0-${date}-1/${isShowKeyword(keyword)}`
                ">
                {{ $t(item.langKey) }}
              </a>
            </div>
          </div>

          <!-- area 1国内, 0国际   v-show="area === 0 || province === 0" -->
          <div
            v-show="type != '9999'"
            class="city_filter filter">
            <div class="label">{{ $t('exhibition.filters.region') }}</div>
            <div>
              <div
                v-show="area == '0'"
                class="city_checkbox value_wrapper region">
                <!-- 洲列表 -->

                <a
                  :title="$t('common.fair')"
                  class="item_a"
                  :class="area == 0 ? 'active' : ''"
                  :href="`/exhibition-${firstIndustryId}-${secondIndustryId}-0-${province}-${city}-${date}-1/${isShowKeyword(keyword)}`">
                  {{ $t('exhibition.filters.all') }}
                </a>
                <a
                  v-for="item in areas"
                  :key="item.id"
                  class="item_a"
                  :class="area == item.id ? 'active' : ''"
                  :title="(item.area || item.regionName) + '展会'"
                  :href="`/exhibition-${firstIndustryId}-${secondIndustryId}-${item.id}-0-0-${date}-1/${isShowKeyword(keyword)}`">
                  {{ item.area || item.regionName }}
                </a>
                <span
                  v-if="areaList.length > 8"
                  class="el-radio"
                  style="margin-bottom: 27px"
                  @click="handleAreaMore">
                  {{ moreArea ? $t('exhibition.filters.packUp') : $t('exhibition.filters.more') }}
                  <el-icon>
                    <ArrowUp v-show="moreArea"></ArrowUp>
                    <ArrowDown v-show="!moreArea"></ArrowDown>
                  </el-icon>
                </span>
              </div>
              <!-- 国内-省份, 国际-国家 -->
              <div
                v-show="Number(area) > 0"
                class="city_checkbox value_wrapper area">
                <a
                  :title="$t('common.fair')"
                  class="item_a"
                  :href="`/exhibition-${firstIndustryId}-${secondIndustryId}-${area}-0-0-${date}-1/${isShowKeyword(keyword)}`">
                  {{ $t('exhibition.filters.all') }}
                </a>
                <a
                  v-for="item in areaList"
                  :key="item.id"
                  v-show="item.hasData === false ? false : Number(item.exhibitionCount) > 0"
                  :href="
                    item.hasData
                      ? `/exhibition-${firstIndustryId}-${secondIndustryId}-${area}-${item.id}-0-${date}-1/${isShowKeyword(keyword)}`
                      : ''
                  "
                  class="item_a"
                  :class="province == item.id ? 'active' : ''"
                  :title="(item.area || item.regionName) + $t('common.fair')">
                  {{ item.area || item.regionName }}
                </a>
                <ClientOnly>
                  <span
                    v-if="cityList.length > 8"
                    class="item_a"
                    style="margin-bottom: 23px"
                    @click="handleAreaMore">
                    {{ moreArea ? $t('exhibition.filters.packUp') : $t('exhibition.filters.more') }}
                    <el-icon>
                      <ArrowUp v-show="moreArea"></ArrowUp>
                      <ArrowDown v-show="!moreArea"></ArrowDown>
                    </el-icon>
                  </span>
                </ClientOnly>
              </div>
            </div>
          </div>
          <!-- 城市 -->
          <div
            v-show="computedProvinceCityList.length > 0"
            class="city_filter filter">
            <div class="label">{{ $t('exhibition.filters.city') }}</div>
            <div>
              <div class="city_checkbox value_wrapper city">
                <a
                  :title="$t('common.fair')"
                  class="item_a"
                  :class="city == 0 ? 'active' : ''"
                  :href="`/exhibition-${firstIndustryId}-${secondIndustryId}-${area}-${province}-0-${date}-1/${isShowKeyword(keyword)}`">
                  {{ $t('exhibition.filters.all') }}
                </a>
                <a
                  v-for="item in computedProvinceCityList"
                  :key="item.id"
                  v-show="item.hasData === false ? false : Number(item.exhibitionCount) > 0"
                  :title="(item.area || item.regionName) + $t('common.fair')"
                  class="item_a"
                  :class="city == item.id ? 'active' : ''"
                  :href="
                    item.hasData
                      ? `/exhibition-${firstIndustryId}-${secondIndustryId}-${area}-${province}-${item.id}-${date}-1/${isShowKeyword(keyword)}`
                      : ''
                  ">
                  {{ item.area || item.regionName }}
                </a>
              </div>
            </div>
          </div>
          <!-- 热门城市 -->
          <div class="city_filter filter">
            <div class="label">{{ $t('exhibition.filters.hotCity') }}</div>
            <div>
              <div
                v-show="hotCityList.length > 0"
                class="city_checkbox value_wrapper">
                <a
                  v-for="item in type === '0'
                    ? hotCityList
                    : type === '1'
                      ? hotCityList2
                      : [...hotCityList, ...hotCityList2]"
                  :key="`${item.regionId}_${item.cityId}`"
                  class="item_a"
                  :class="city == item.cityId ? 'active' : ''"
                  :title="item.name + $t('common.fair')"
                  :href="`/exhibition-${firstIndustryId}-${secondIndustryId}-${item.areaId}-${item.regionId}-${item.cityId}-${date}-1/${isShowKeyword(keyword)}`">
                  {{ item.name }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="banner.length > 0"
        class="banner-area">
        <div
          v-for="item in banner.slice(0, 1)"
          class="banner-tag">
          <a
            :href="item.link"
            target="_blank">
            <NuxtImg
              :src="item.url"
              class="banner-img"
              loading="lazy" />
          </a>
        </div>
      </div>
      <div class="exh_sort">
        <div class="bread row-flex align-content-c">
          <nuxt-link
            :title="$t('common.site_title')"
            target="_blank"
            to="/"
            prefetch-on="interaction">
            {{ $t('menu.home') }}
          </nuxt-link>
          <el-icon>
            <ArrowRight />
          </el-icon>
          <nuxt-link
            v-if="checkTags.length > 0"
            prefetch-on="interaction"
            :title="$t('common.site_title')"
            :to="type === '1' ? `/exhibition/` : `/exhibition-0-0-1-0-0-0-1/`"
            target="_blank">
            {{ type === '1' ? $t('menu.international') : $t('menu.domestic') }}
          </nuxt-link>
          <span v-else>
            {{ type === '1' ? $t('menu.international') : $t('menu.domestic') }}
          </span>
          <template v-if="checkTags.length > 0">
            <el-icon>
              <ArrowRight />
            </el-icon>
            <span>{{ brandName(checkTags) }}{{ $t('common.fair') }}</span>
          </template>
        </div>
        <div class="exh_sort_list">
          <div class="select_container">
            <el-button
              :class="activeSort === 'scale' ? 'active-sort' : ''"
              size="small"
              @click="handleGetFairList(scale)">
              {{ $t('exhibition.scale') }}
              <el-icon>
                <CaretBottom v-show="scale.sortType === 'asc'" />
                <CaretTop v-show="scale.sortType !== 'asc'" />
              </el-icon>
            </el-button>
          </div>
          <div class="select_container">
            <el-button
              :class="activeSort === 'hot' ? 'active-sort' : ''"
              size="small"
              @click="handleGetFairList(hot)">
              {{ $t('exhibition.heatSort') }}
              <el-icon>
                <CaretBottom v-show="hot.sortType === 'asc'" />
                <CaretTop v-show="hot.sortType !== 'asc'" />
              </el-icon>
            </el-button>
          </div>
          <div class="select_container">
            <el-button
              :class="activeSort === 'start_time' ? 'active-sort' : ''"
              size="small"
              @click="handleGetFairList(start_time)">
              {{ $t('exhibition.timeSort') }}
              <el-icon>
                <CaretBottom v-show="start_time.sortType === 'asc'" />
                <CaretTop v-show="start_time.sortType !== 'asc'" />
              </el-icon>
            </el-button>
          </div>
          <!--        <el-button-->
          <!--          type="primary"-->
          <!--          size="small"-->
          <!--          class="release_exh"-->
          <!--          @click="handleRelease"-->
          <!--        >-->
          <!--          发布展会-->
          <!--        </el-button>-->
        </div>
      </div>
      <!-- 展会列表,不包含推荐 -->
      <div
        v-if="get(fair, 'records', []).length > 0"
        class="exh_list">
        <goods-item
          v-for="(item, index) in get(fair, 'records', [])"
          :key="item.id"
          :data="item"
          :currentIndex="index"
          :industry-id="+secondIndustryId"
          class="goods_exh" />
      </div>
      <!-- <empty v-else style="margin: 12px 0" /> -->
      <div
        v-else
        class="empty-container">
        <div>“{{ getBrandName }}{{ $t('common.fair') }}”{{ $t('exhibition.updating') }}</div>
        <div>
          为了满足您的需求，我们为您推荐了{{
            getBrandNameIndustry
          }}同期其他展会的信息，希望能对您有所帮助。
          <br />
          如需参展/参观可咨询在线客服
        </div>
        <div class="row-flex jc">
          <div
            class="server-button cursor-pointer"
            @click="handleOnlineService">
            咨询客服
          </div>
        </div>
      </div>
      <!-- 行业推荐 -->
      <template
        v-if="
          isRecommond &&
          get(hotFair, 'records', []).length > 0 &&
          get(fair, 'records', []).length == 0
        ">
        <div class="title_more">
          <section-title
            :title="sectionTitle1(checkTags, $t('exhibition.recommendedExhibition'))"
            style="font-size: 20px; font-weight: bold" />
          <p class="more">
            <nuxt-link
              :to="`/exhibition-${firstIndustryId}-${secondIndustryId}-${area}-${province}-${city}-${date}-1/${isShowKeyword(keyword)}`"
              prefetch-on="interaction">
              {{ $t('common.more') }}
              <el-icon>
                <ArrowRight />
              </el-icon>
            </nuxt-link>
          </p>
        </div>
        <div class="exh_list">
          <goods-item
            v-for="(item, index) in get(hotFair, 'records', [])"
            :key="item.id"
            :currentIndex="index"
            :data="item"
            :industry-id="+secondIndustryId"
            class="goods_exh"
            is-hot />
          <goods-item
            v-for="(item, index) in get(fair, 'records', [])"
            :key="item.id"
            :currentIndex="index"
            :data="item"
            :industry-id="+secondIndustryId"
            class="goods_exh" />
        </div>
      </template>

      <Pagination
        v-if="pagination"
        :confirm-btn="true"
        :current-page="pageNum"
        :first-link="
          firstLink(
            `/exhibition-${firstIndustryId}-${secondIndustryId}-${area}-${province}-${city}-${date}-1/`
          )
        "
        :link="`/exhibition-${firstIndustryId}-${secondIndustryId}-${area}-${province}-${city}-${date}-`"
        :page-size="pageSize"
        :total="fair.total"
        :use-a-link="true"
        @changePager="changePager" />

      <div
        v-if="otherFairList.length > 0"
        class="other-fair">
        <section-title
          :title="`${getBrandName}${$t('exhibition.concurrentFair')}`"
          style="font-size: 20px; font-weight: bold; margin-bottom: 18px" />
        <div class="other-fair-list">
          <div
            v-for="(item, index) in otherFairList"
            :key="index"
            class="item row-flex ac">
            <div class="name">
              <h2
                class="exhibition-name cursor-pointer"
                @click="handleToDetail(item.exhibitionId)">
                {{ item.exhibitionName }}
              </h2>
            </div>
            <div class="time">{{ item.lunchTime }}</div>
            <div class="area">
              {{ item.area }}
              <template v-if="item.cityId && item.cityName">
                {{ item.cityName }}
              </template>
            </div>
            <div class="controls">
              <div class="button-box row-flex-wrap">
                <nuxt-link
                  :to="`/exhibition/apply/${item.exhibitionId}.html`"
                  rel="nofollow"
                  target="_blank"
                  prefetch-on="interaction">
                  展位
                </nuxt-link>
                <nuxt-link
                  :to="`/ticket/${item.exhibitionId}.html`"
                  rel="nofollow"
                  target="_blank"
                  prefetch-on="interaction">
                  门票
                </nuxt-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="data-total"
        class="data-total"
        style="display: none">
        {{ fair.total }}
      </div>
      <!-- 地区/行业 资讯 -->
      <template v-if="news.length > 0">
        <div class="title_more">
          <section-title
            :title="sectionTitle2(checkTags, $t('exhibition.industryNews'), area)"
            style="font-size: 20px; font-weight: bold" />
          <p class="more">
            <nuxt-link
              :title="sectionTitle2(checkTags, $t('exhibition.industryNews'), area)"
              :to="`/information-1-${listParams.industryId || 0}-1/`"
              target="_blank"
              prefetch-on="interaction">
              {{ $t('common.more') }}
            </nuxt-link>
            <el-icon>
              <ArrowRight />
            </el-icon>
          </p>
        </div>
        <div class="exh_news_container">
          <div class="news_left">
            <div class="news-cover">
              <nuxt-link
                :title="get(news, '[0].newsName', '')"
                :to="handleNewsUrl(get(news, '[0].viewUrl', ''), get(news, '[0].newsId', ''))"
                target="_blank"
                prefetch-on="interaction">
                <NuxtImg
                  :src="getWebp(get(news, '[0].logo', ''))"
                  :alt="get(news, '[0].newsName', '')"
                  loading="lazy" />
              </nuxt-link>
              <!-- :src="get(news, '[0].logo', '')" -->
            </div>
            <div class="news_info">
              <p class="name">
                <i
                  class="el-icon-toutiao"
                  style="width: 24px"></i>
                <span>
                  <nuxt-link
                    :title="get(news, '[0].newsName', '')"
                    :to="handleNewsUrl(get(news, '[0].viewUrl', ''), get(news, '[0].newsId', ''))"
                    target="_blank"
                    prefetch-on="interaction">
                    {{ get(news, '[0].newsName', '') }}
                  </nuxt-link>
                </span>
              </p>
              <p class="time">
                <span style="margin-right: 15px">
                  {{ get(news, '[0].createTime', '') }}
                </span>
                <i
                  class="el-icon-look"
                  style="width: 12px; margin-right: 4px" />
                <span>{{ get(news, '[0].views', 0) }}</span>
              </p>
              <div class="content">
                {{ description(get(news, '[0]', {})) }}
              </div>
            </div>
          </div>
          <div class="right_left">
            <ul>
              <li
                v-for="item in news.slice(1)"
                :key="item.newsId">
                <span class="red_dot"></span>
                <span class="sub_tit">
                  <nuxt-link
                    :title="item.newsName"
                    :to="handleNewsUrl(item.viewUrl, item.newsId)"
                    target="_blank"
                    prefetch-on="interaction">
                    {{ item.newsName }}
                  </nuxt-link>
                </span>
                <i
                  class="el-icon-look"
                  style="width: 12px"></i>
                <span class="look">{{ item.views }}</span>
              </li>
            </ul>
          </div>
        </div>
      </template>

      <!-- 最新展会动态资讯 地区/行业资讯 type == 1 国际-->
      <template v-if="newsList.length > 10">
        <div class="title_more">
          <section-title
            :title="$t('exhibition.latestNews')"
            style="font-size: 20px; font-weight: bold" />
          <p class="more">
            <nuxt-link
              :title="$t('exhibition.latestNews')"
              :to="`/information/`"
              target="_blank"
              prefetch-on="interaction">
              {{ $t('common.more') }}
            </nuxt-link>
            <el-icon>
              <ArrowRight />
            </el-icon>
          </p>
        </div>
        <div class="exh_news">
          <div class="exh_news_left">
            <ul>
              <li
                v-for="item in newsList.slice(10, 15)"
                :key="item.newsId">
                <span class="red_dot"></span>
                <span class="sub_tit">
                  <nuxt-link
                    :title="item.newsName"
                    :to="handleNewsUrl(item.viewUrl, item.newsId)"
                    target="_blank"
                    prefetch-on="interaction">
                    {{ item.newsName }}
                  </nuxt-link>
                </span>
                <span class="look">{{ item.createTime }}</span>
              </li>
            </ul>
          </div>
          <div class="exh_news_right">
            <ul>
              <li
                v-for="item in newsList.slice(15, 20)"
                :key="item.newsId">
                <span class="red_dot"></span>
                <span class="sub_tit">
                  <nuxt-link
                    :title="item.newsName"
                    :to="handleNewsUrl(item.viewUrl, item.newsId)"
                    target="_blank"
                    prefetch-on="interaction">
                    {{ item.newsName }}
                  </nuxt-link>
                </span>
                <span class="look">{{ item.createTime }}</span>
              </li>
            </ul>
          </div>
        </div>
      </template>

      <div class="hot_country">
        <div class="tab_head row-flex">
          <div
            :class="{ active: innerChainActive == 0 }"
            class="tab_name"
            @click="handleHotTab(0)">
            热门地区
          </div>
          <div
            :class="{ active: innerChainActive == 1 }"
            class="tab_name"
            @click="handleHotTab(1)">
            热门行业
          </div>
          <div
            :class="{ active: innerChainActive == 2 }"
            class="tab_name"
            @click="handleHotTab(2)">
            热门展会
          </div>
        </div>
        <div class="country_list">
          <div
            v-show="innerChainActive == 0"
            class="tab_content row-flex-wrap">
            <a
              v-for="item in innerChainAreaList"
              :key="item.id"
              :href="item.url"
              :title="item.content"
              target="_blank">
              {{ item.content }}
            </a>
          </div>
          <div
            v-show="innerChainActive == 1"
            class="tab_content row-flex-wrap">
            <a
              v-for="item in innerChainIndustryList"
              :key="item.id"
              :href="item.url"
              :title="item.content"
              target="_blank">
              {{ item.content }}
            </a>
          </div>
          <div
            v-show="innerChainActive == 2"
            class="tab_content row-flex-wrap">
            <a
              v-for="item in innerChainExhList"
              :key="item.id"
              :href="item.url"
              :title="item.content"
              target="_blank">
              {{ item.content }}
            </a>
          </div>
        </div>
      </div>
      <!-- <div class="bottom-az">
        <div
          v-for="item in azList"
          :key="item">
          <nuxt-link
            :to="`sitemap_${item.toLowerCase()}`"
            :title="`展会推荐-${item}`"
            target="_blank" prefetch-on="interaction">
            <h4>{{ item }}</h4>
          </nuxt-link>
        </div>
      </div> -->
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
  // import { getWebp } from '~/putils/format'
  import { handleNewsUrl, handleCheckUrl, getWebp } from '~/utils/common'
  import dayjs from 'dayjs'
  import { ArrowDown, ArrowRight, ArrowUp, CaretBottom, CaretTop } from '@element-plus/icons-vue'
  import { useFairList } from '~/composables/fair/useFairList'
  import { ELocale } from '~~/types/enums'

  const GoodsItem = defineAsyncComponent(() => import('~/components/Goods/item.vue'))
  const SectionTitle = defineAsyncComponent(() => import('~/components/SectionTitle/index.vue'))
  const Pagination = defineAsyncComponent(() => import('~/components/Pagination/index.vue'))
  const {
    firstIndustryId,
    secondIndustryId,
    area,
    province,
    city,
    date,
    page,
    pageNum,
    pageSize,
    listParams,
    type,
    keyword,
    keywordError,
    keywordPlaceholder,
    moreDate,
    moreCity,
    moreArea,
    pagination,
    isRecommond,
    activeSort,
    innerChainActive,
    cityList,
    azList,
    scale,
    hot,
    start_time,
    hotCityList,
    hotCityList2,
    typeList,
    banner,
    newsList,
    industry,
    areas,
    fair,
    news,
    hotFair,
    checkTags,
    secondIndustry,
    provinceCityList,
    otherFairList,
    innerChainAreaList,
    innerChainIndustryList,
    innerChainExhList,
    areaList,
    computedProvinceCityList,
    dates,
    getBrandName,
    getBrandNameIndustry,
    sectionTitle1,
    sectionTitle2,
    description,
    brandName,
    firstLink,
    handleKeywordInput,
    handleSearch,
    newUrl,
    handleAreaMore,
    handleCityMore,
    handleDateMore,
    handleGetFairList,
    handleOnlineService,
    handleToDetail,
    handleHotTab,
    changePager,
    areaChange,
    get,
    isLogin,
    toAllCity,
    isShowKeyword
  } = await useFairList(ELocale.cn)
  // useHead
  useHead(() => {
    let title = ''
    let keywords = ''
    let description = ''

    let pageText = ''
    let _year = dayjs().year()
    let _month = 0
    let _date = ''

    const currentYear = new Date().getFullYear() // 当前年份
    const currentMonth = new Date().getMonth() // 当前月份
    let dateYearMonth = '' // 年月 格式:202409
    let dateMonth = date.value

    if (+date.value > 0) {
      if (date.value.length == 6) {
        dateMonth = date.value.slice(4) // 获取最后两位
      }

      if (Number(dateMonth) < currentMonth + 1) {
        dateYearMonth = `${currentYear + 1}${
          Number(dateMonth) < 10 ? '0' + Number(dateMonth) : dateMonth
        }`
      } else {
        dateYearMonth = `${currentYear}${
          Number(dateMonth) < 10 ? '0' + Number(dateMonth) : dateMonth
        }`
      }
      _year = dayjs(dateYearMonth).year()
      _month = dayjs(dateYearMonth).month() + 1
      _date = `${_year}年${_month}月`
    }
    // console.log('2088-', date.value);

    let firstIndustry: Record<string, any> = {} // 一级行业
    let secondIndustry: Record<string, any> = {} // 二级行业
    let continent: Record<string, any> = {} // 洲,国
    let areaObj: Record<string, any> = {} // 省份(国内)/国家(国际)
    let cityObj: Record<string, any> = {} // 城市

    if (+firstIndustryId.value > 0) {
      firstIndustry = industry.find(
        (item: { industryId: string }) => +item.industryId === +firstIndustryId.value
      )
    }

    if (+secondIndustryId.value > 0) {
      secondIndustry = firstIndustry.children.find(
        (item: { id: string }) => +item.id === +secondIndustryId.value
      )
    }

    if (+area.value > 0) {
      continent = areas.find((item: { id: string }) => +item.id === +area.value)
    }

    if (+province.value > 0) {
      areaObj = continent.areas.find((item: { id: string }) => +item.id === +province.value)
    }
    //  area.hasOwnProperty('areas') 是为了容错原url, 搜索引擎会访问（cityId位置写的是日期）exhibition-39-178-0-0-202011-202407-2/
    if (+city.value > 0 && areaObj.hasOwnProperty('areas')) {
      // console.log('2055-', area);
      cityObj = areaObj.areas.find((item: { id: string }) => +item.id === +city.value)
    }

    let cityName = ''
    if (cityObj && cityObj.area) {
      cityName =
        cityObj.area?.substr(-1) == '市'
          ? cityObj.area?.substr(0, cityObj.area.length - 1)
          : cityObj.area
    }

    let areaName = '' // 地区名称,国内是省份名称,国外是国家名称
    if (+type.value === 1 && areaObj && areaObj.area) areaName = areaObj.area

    let address = cityName || (areaObj && areaObj.area) || (continent && continent.regionName) || ''
    // 如果是国外地区 且 选择了城市, 前面加上地区名称
    if (+type.value === 1 && cityName) address = `${areaName}${address}`

    if (+page.value > 1) {
      pageText = `_第${page.value}页`
    }
    // 国内
    if (+type.value === 0) {
      title = `国内展会_中国展会_中国博览会_中国交易会_${_year}年中国展览会信息${pageText}-聚展`
      keywords = `国内展会,中国展会,中国会展,中国展会信息,${keyword.value}`
      description = `聚展网为您提供${_year}最新最全的中国展,中国展会排期,中国展览会信息及资讯,展会门票,展位预订,博览会门票,展会时间,是您参展中国展会最好的展会服务平台`
    } else {
      title = `国际展会_国际博览会_国际展览会信息服务平台${keyword.value}${pageText}-聚展`
      keywords = `国际展会,国际展会信息,国外展会,国际展览会,国外展览会,${keyword.value}`
      description =
        '聚展网为您提供最新国际展览会,国外展会,国际会展中心展会信息,为您提供参展选展最佳指导方案,国际展览会中心最新展会资讯'
    }
    // 地区
    if (address) {
      title = `${address}展会_${_year}年${address}展览会_时间_门票${pageText}-聚展`
      keywords = `${address}展会,${address}展览会,${address}博览会,${address}交易会`
      description = `聚展网提供${_year}最新最全的${address}展,${address}展会排期,${address}展览会信息及资讯,展会门票,展位预订,博览会门票,展会时间,是您参展${address}展会最好的展会服务平台`
    }
    // 时间
    if (+date.value > 0) {
      const _address = +type.value === 0 ? '中国' : '国际'
      const _prefix = `${_date}${_address}`

      title = `${_prefix}展会信息_${_address}博览会_${_address}交易会${pageText}-聚展`
      keywords = `${_prefix}展览会,${_prefix}展会时间,${_prefix}展会地点`
      description = `聚展网为您提供${_prefix}展会信息,${_date}展会排期,展会门票,为您参展选展提供最佳指导方案`
    }
    // 一级行业
    switch (firstIndustryId.value) {
      case '16': // 车／配件
        title = `${_date}${address}车展_汽配摩配展_电动车展_自行车展_改装车展_${keyword.value}${pageText}-聚展`
        keywords = `${address}车博览会,${address}汽配摩配博览会,电动车博览会,自行车博览会,改装车博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
      case '19': // 五金/建材
        title = `${_date}${address}五金展_建材展_暖通制冷展_地铺展_玻璃展${keyword.value}${pageText}-聚展`
        keywords = `${address}五金博览会,${address}建材博览会,暖通制冷博览会,地铺博览会,玻璃博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
      case '26': // 工业/机械
        title = `${_date}${address}工业展_工程机械展_机器人展_木工展_自动化展${keyword.value}${pageText}-聚展`
        keywords = `${address}工业博览会,${address}工程机械博览会,机器人博览会,木工博览会,自动化博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
      case '27': // 电子/电力
        title = `${_date}${address}电子展_电力展_照明展_光电展_灯光舞台展${keyword.value}${pageText}-聚展`
        keywords = `${address}电子博览会,${address}电力博览会,照明博览会,光电博览会,灯光舞台博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
      case '28': // 通信/网络
        title = `${_date}${address}通讯展_通信展_游戏展_智能识别展_互联网展${keyword.value}${pageText}-聚展`
        keywords = `${address}通讯博览会,${address}通信博览会,游戏博览会,智能识别博览会,互联网博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
      case '29': // 能源化工
        title = `${_date}${address}能源展_化工展_太阳能展_环保展_电池展${keyword.value}${pageText}-聚展`
        keywords = `${address}能源博览会,${address}化工博览会,太阳能博览会,环保博览会,电池博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
      case '30': // 交通航天
        title = `${_date}${address}交通展_航空航天展_运输物流展_船舶海事展${keyword.value}${pageText}-聚展`
        keywords = `${address}交通博览会,${address}航空航天博览会,运输物流博览会,船舶海事博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
      case '31': // 安防劳保
        title = `${_date}${address}安防展_劳保展_防务展_军警展_公共安全展${keyword.value}${pageText}-聚展`
        keywords = `${address}安防博览会,${address}劳保博览会,防务博览会,军警博览会,公共安全博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
      case '32': // 纺织服装
        title = `${_date}${address}纺织面料服装展_鞋包展_珠宝钟表展_箱包皮革展${keyword.value}${pageText}-聚展`
        keywords = `${address}纺织面料服装博览会,${address}鞋包博览会,珠宝钟表博览会,箱包皮革博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
      case '33': // 生物医疗
        title = `${_date}${address}生物制药展_医疗设备展_美容美发展_成人用品展${keyword.value}${pageText}-聚展`
        keywords = `${address}生物制药博览会,${address}医疗设备博览会,美容美发博览会,成人用品博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
      case '34': // 消费家电
        title = `${_date}${address}日用消费品展_礼品展_家具展_消费电子展${keyword.value}${pageText}-聚展`
        keywords = `${address}日用消费品博览会,${address}礼品博览会,家具博览会,消费电子博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
      case '35': // 旅游户外
        title = `${_date}${address}户外体育用品展_实验仪器展_旅游用品展_教育展${keyword.value}${pageText}-聚展`
        keywords = `${address}户外体育用品博览会,${address}实验仪器博览会,旅游用品博览会,教育博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
      case '36': // 广告影视
        title = `${_date}${address}印刷包装展_纸业展_游戏娱乐展_影视器材展${keyword.value}${pageText}-聚展`
        keywords = `${address}印刷包装博览会,${address}纸业博览会,游戏娱乐博览会,影视器材博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
      case '37': // 办公婴童
        title = `${_date}${address}办公文具展_婴童用品展_玩具展_宠物展_${keyword.value}${pageText}-聚展`
        keywords = `${address}办公文具博览会,${address}婴童用品博览会,玩具博览会,宠物博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
      case '38': // 农业牧业
        title = `${_date}${address}农业展_畜牧展_饲料展_园林园艺展_渔业展_${keyword.value}${pageText}-聚展`
        keywords = `${address}农业博览会,${address}畜牧博览会,饲料博览会,园林园艺博览会,渔业博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
      case '39': // 食品生鲜
        title = `${_date}${address}食品饮料展_烟草展_酒类展_果蔬展_咖啡茶展_${keyword.value}${pageText}-聚展`
        keywords = `${address}食品饮料博览会,${address}烟草博览会,酒类博览会,果蔬博览会,咖啡茶博览会,${keyword.value}`
        description = `聚展网_提供${keywords}等行业展览会介绍和展会资讯,为您提供订展一站式服务,报道${_year}最新最全展览会资讯`
        break
    }
    // 二级行业
    if (+secondIndustryId.value > 0) {
      const name = secondIndustry?.industryName

      title = `${name}展会_${_year}年国际${name}展览会_${name}博览会${pageText}-聚展`
      keywords = `${name}展门票,${name}展会时间,${name}展览会地点,${name}博览会展位,${name}展会信息`
      description = `聚展网为您提供最新${name}展会排期表,${name}展会信息,${name}展会门票,${name}展会会刊,${name}展会展位预定,专业的一站式展会服务平台`
    }
    // 地区+二级行业
    if (address && +secondIndustryId.value > 0) {
      const secondIndustryName = secondIndustry?.industryName
      const _preFix = `${address}${secondIndustryName}`

      const ext = +type.value === 0 ? '' : '_邀请函'
      title = `${_preFix}展会有哪些?_${_preFix}展会信息_展商信息${ext}-聚展`
    }
    // 城市+二级行业
    if (+city.value > 0 && +secondIndustryId.value > 0) {
      const secondIndustryName = secondIndustry?.industryName
      const _preFix = `${address}${secondIndustryName}`

      title = `${_preFix}展_${_preFix}博览会信息${pageText}-聚展`
      keywords = ''
      description =
        '聚展网为您提供最新国际展览会,国外展会,国际会展中心展会信息,为您提供参展选展最佳指导方案,国际展览会中心最新展会资讯'
    }
    // 时间+二级行业
    if (+date.value > 0 && +secondIndustryId.value > 0) {
      const secondIndustryName = secondIndustry?.industryName

      title = `${secondIndustryName}展会_${_date}国际${secondIndustryName}博览会_时间_门票${pageText}${pageText}-聚展`
      keywords = `${_date}${secondIndustryName}展,${_date}${secondIndustryName}展会,${_date}${secondIndustryName}展览会,${_date}${secondIndustryName}博览会,${_date}${secondIndustryName}展销会,${_date}${secondIndustryName}展会信息`
      description = `聚展网-提供${_date}${secondIndustryName}展会排期,${_date}${secondIndustryName}展会信息,${_date}${secondIndustryName}展会时间,${_date}${secondIndustryName}展会门票,为您出国参加${secondIndustryName}展会更加方便的展会网-专注打造一站式展会网络服务平台`
    }
    // 时间+地区+国际展会
    if (+date.value > 0 && address && +firstIndustryId.value === 0) {
      const _prefix = `${_date}${address}`

      title = `${address}展会_${_prefix}博览会_时间_门票${pageText}-聚展`
      keywords = `${_prefix}展,${_prefix}展会,${_prefix}展览会,${_prefix}博览会,${_prefix}展销会,${_prefix}展会信息`
      description = `聚展网-提供${_prefix}展会排期,${_prefix}展会信息,${_prefix}展会时间,${_prefix}展会门票,为您出国参加展会更加方便的展会网-专注打造一站式展会网络服务平台`
    }
    // 时间+地区+二级行业
    if (+date.value > 0 && address && +secondIndustryId.value > 0) {
      const secondIndustryName = secondIndustry?.industryName
      const _prefix = `${_date}${address}${secondIndustryName}`

      title = `${address}${secondIndustryName}展会_${_prefix}博览会_时间_门票${pageText}-聚展`
      keywords = `${_prefix}展,${_prefix}展会,${_prefix}展览会,${_prefix}博览会,${_prefix}展销会,${_prefix}展会信息`
      description = `聚展网-提供${_prefix}展会排期,${_prefix}展会信息,${_prefix}展会时间,${_prefix}展会门票,为您出国参加${secondIndustryName}展会更加方便的展会网-专注打造一站式展会网络服务平台`
    }
    // 右上角输入框搜索内容
    if (keyword.value) {
      title = `${keyword.value}${pageText}-聚展`
      keywords = `${keyword.value},展览会,博览会,交易会,展会时间,展会地点,展会门票`
      description = `聚展网为您提供${_year}最新最全的${keyword.value},${keyword.value}展会排期,${keyword.value}展览会信息及资讯,是您参展${keyword.value}展会最好的展会服务平台`
    }

    return {
      title,
      meta: [
        {
          name: 'mobile-agent',
          'http-equiv': 'mobile-agent',
          content: `format=html5; url=https://m.jufair.com/exhibition-${firstIndustryId.value}-${secondIndustryId.value}-${area.value}-${province.value}-${city.value}-${date.value}-${page.value}`
        },
        {
          name: 'keywords',
          content: keywords
        },
        {
          name: 'description',
          content: description
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: `https://www.jufair.com/exhibition-${firstIndustryId.value}-${secondIndustryId.value}-${area.value}-${province.value}-${city.value}-${_month}-1/`
        }
      ]
    }
  })
</script>

<style lang="less" scoped>
  .china_exh_list {
    width: 1190px;
    margin: 0 auto;

    .search_count {
      width: 500px;
      height: 56px;
      margin-bottom: 15px;
      border-radius: 6px;
      position: relative;

      .el-input__inner {
        height: 56px;
        font-size: 16px;
        color: #333;
        padding-right: 53px;

        &::placeholder {
          color: #777;
        }
      }

      .keyword-error {
        .el-input__inner {
          border: 1px solid #f00;
          color: #f00;

          &::placeholder {
            color: #f00;
          }
        }
      }

      .search-btn {
        position: absolute;
        width: 53px;
        height: 38px;
        top: 1px;
        right: 2px;
        background: #fff;
        border: none;
        font-size: 20px;

        :deep(.el-icon-search) {
          position: relative;
          top: -2px;
        }
      }
    }

    .title_more {
      display: flex;
      align-items: center;
      margin-top: 25px;
      margin-bottom: 18px;

      .more {
        margin-left: auto;
        font-size: 16px;
        font-weight: 400;
        color: #333;
      }
    }

    .choose_box {
      background: #fff;
      padding: 23px 28px 0;
      border-radius: 6px;
      margin-top: 20px;

      .filter_container {
        padding: 10px;
        margin-top: 20px;

        .value_wrapper {
          padding: 1px 0 0 0;

          .checked-tag {
            background: transparent;
            margin: 0 24px 24px 0;
            border: 1px solid @app-color;
          }
        }

        // 单选框使用多选框样式
        .el-radio-group {
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
        }

        .el-radio {
          //line-height: 1.4;
          display: flex;
          align-items: center;
          justify-content: center;
          height: unset;
          line-height: 1;
        }

        .el-radio__label {
          font-size: 16px;
          font-family: Helvetica, sans-serif;
        }

        .el-radio__inner {
          display: inline-block;
          position: relative;
          border-radius: 2px;
          box-sizing: border-box;
          width: 14px;
          height: 14px;
          z-index: 1;
          transition:
            border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
            background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);

          &::after {
            box-sizing: content-box;
            content: '';
            border: 1px solid #fff;
            border-left: 0;
            border-top: 0;
            height: 7px;
            left: 4px;
            position: absolute;
            top: 1px;
            transform: rotate(45deg) scaleY(1);
            width: 3px;
            transition: transform 0.15s ease-in 0.05s;
            transform-origin: center;
            border-radius: 0;
            background: transparent;
          }
        }

        .filter {
          display: flex;
          margin-bottom: 18px;

          .label {
            width: 66px;
            font-size: 16px;
            text-align: justify;
            text-align-last: justify;
            color: #333;
            flex-shrink: 0;
            margin-right: 49px;
            margin-top: 4px;
          }
          .item_a {
            margin: 0px 24px 24px 0px;
            display: inline-block;
            // font-weight: bold;
            position: relative;
            z-index: 2;
            &.active {
              color: #e50113;
              padding: 2px 6px;
              border: solid 1px #e50113;
              border-radius: 4px;
              // &::after {
              //   position: absolute;
              //   bottom: -4px;
              //   left: 0;
              //   z-index: -1;
              //   content: '';
              //   display: inline-block;
              //   width: 100%;
              //   height: 10px;
              //   background: #ff5555;
              //   // border-radius: 50%;
              //   // margin-right: 8px;
              // }
            }

            &:hover {
              cursor: pointer;
            }
            &.disable {
              // color: #909399;
              &:hover {
                color: #909399 !important;
              }
            }
          }
          .time_item {
            &.disable {
              color: #909399;
            }
          }
        }

        .more-btn {
          font-size: 14px;
          cursor: pointer;
        }
      }
    }

    .exh_sort {
      width: 1190px;
      height: 58px;
      background: #fff;
      border-radius: 6px;
      margin-top: 12px;
      display: flex;
      align-items: center;
      padding: 13px 32px;

      .bread {
        font-size: 14px;
        color: #333;
        flex: 1;
      }

      .exh_sort_list {
        display: flex;

        .select_container {
          margin-right: 24px;

          .el-button--small {
            height: auto;
            padding: 9px 15px;
          }
        }

        .active-sort {
          color: #e50113;
          border-color: #f7b3b8;
          background-color: #fce6e7;
        }

        .release_exh {
          color: #fff;
          font-size: 16px;
          padding: 8px 15px;
        }
      }
    }

    .exh_list {
      display: flex;
      flex-wrap: wrap;
      margin: 12px 0 0;

      .goods_exh {
        margin-right: 12px;

        &:nth-child(2n) {
          margin-right: 0;
        }
      }
    }

    .empty-container {
      margin: 0 auto;
      background: #fff;
      border-radius: 6px;
      overflow: hidden;
      text-align: center;
      font-size: 16px;
      padding: 30px 0;
      line-height: 24px;

      .server-button {
        width: 100px;
        height: 30px;
        margin-top: 5px;
        line-height: 30px;
        border-radius: 5px;
        color: #fff;
        background: rgba(229, 1, 19);
      }
    }

    .other-fair {
      margin-top: 25px;

      .other-fair-list {
        .item {
          padding: 10px;
          font-size: 17px;
          background: #fff;

          .name {
            width: 450px;
          }

          .time {
            width: 180px;
          }

          .area {
            width: 430px;
          }

          .controls {
            width: 130px;
          }
        }

        .exhibition-name {
          font-size: 18px;
          font-weight: 500;
          color: #1d5377;
        }

        .button-box {
          gap: 10px;

          a {
            padding: 5px 8px;
            color: #fff;
            background: #1891cc;
            border-radius: 5px;

            &:hover {
              color: #fff;
            }
          }
        }
      }
    }

    .about-main,
    .range-main {
      margin: 10px 0;
      padding: 24px 16px;
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 6px;
      line-height: 24px;
    }

    .ssr-pager {
      background: #fff;
      margin-bottom: 22px;
      border-radius: 6px;
    }

    .exh_news_container {
      display: flex;
      margin-bottom: 22px;

      .news_left {
        width: 708px;
        padding: 24px 16px;
        margin-right: 12px;
        display: flex;
        align-items: center;
        background: #fff;
        border-radius: 6px;

        .news-cover {
          width: 236px;
          height: 138px;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          border: 1px solid #ddd;
          margin-right: 18px;
          border-radius: 4px;
          flex-shrink: 0;

          img {
            width: 236px;
            height: auto;
          }
        }

        .news_info {
          height: 100%;
          padding: 4px 0;

          .name {
            font-size: 16px;
            font-weight: bold;
            color: #333;
            width: 420px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .time {
            display: flex;
            font-size: 14px;
            color: #999;
            margin-top: 10px;
          }

          .content {
            margin-top: 18px;
            line-height: 24px;
            font-size: 14px;
            color: #666;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box; //作为弹性伸缩盒子模型显示。
            -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
            -webkit-line-clamp: 3; //显示的行
          }
        }
      }

      .right_left {
        flex: 1;
        background: #fff;
        border-radius: 6px;
        padding: 14px 20px;

        ul {
          display: flex;
          flex-flow: column;
          // justify-content: space-around;
          height: 100%;

          li {
            list-style: none;
            display: flex;
            align-items: center;
            font-size: 16px;
            color: #555;
            margin-bottom: 11px;

            &:last-child {
              margin-bottom: 0;
            }

            .red_dot {
              display: inline-block;
              width: 4px;
              height: 4px;
              background: #e50113;
              margin-right: 7px;
            }

            .sub_tit {
              display: inline-block;
              width: 348px;
              overflow: hidden; //超出的文本隐藏
              text-overflow: ellipsis; //溢出用省略号显示
              white-space: nowrap;
              margin-right: 22px;
            }

            .look {
              color: #999;
              font-size: 14px;
              margin-left: 2px;
            }
          }
        }
      }
    }

    .exh_news {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      margin-bottom: 12px;

      .exh_news_left {
        width: 589px;
        background: #fff;
        border-radius: 6px;
        padding: 14px 20px;

        ul {
          display: flex;
          flex-flow: column;
          // justify-content: space-around;
          height: 100%;

          li {
            list-style: none;
            display: flex;
            align-items: center;
            font-size: 16px;
            color: #555;
            margin-bottom: 11px;

            &:last-child {
              margin-bottom: 0;
            }

            .red_dot {
              display: inline-block;
              width: 4px;
              height: 4px;
              background: #e50113;
              margin-right: 7px;
            }

            .sub_tit {
              display: inline-block;
              width: 500px;
              overflow: hidden; //超出的文本隐藏
              text-overflow: ellipsis; //溢出用省略号显示
              white-space: nowrap;
              margin-right: 22px;
            }
          }
        }
      }

      .exh_news_right {
        width: 50%;
        margin-left: 12px;
        background: #fff;
        border-radius: 6px;
        padding: 14px 20px;

        ul {
          display: flex;
          flex-flow: column;
          // justify-content: space-around;
          height: 100%;

          li {
            list-style: none;
            display: flex;
            align-items: center;
            font-size: 16px;
            color: #555;
            margin-bottom: 11px;

            &:last-child {
              margin-bottom: 0;
            }

            .red_dot {
              display: inline-block;
              width: 4px;
              height: 4px;
              background: #e50113;
              margin-right: 7px;
            }

            .sub_tit {
              display: inline-block;
              width: 500px;
              overflow: hidden; //超出的文本隐藏
              text-overflow: ellipsis; //溢出用省略号显示
              white-space: nowrap;
              margin-right: 22px;
            }
          }
        }
      }
    }

    .banner-area {
      width: 1190px;
      margin-top: 12px;

      .banner-tag {
        > a {
          > img {
            width: 1190px;
            border-radius: 6px;
          }
        }
      }
    }

    .hot_country {
      width: 1190px;
      margin: 16px auto;
      padding: 20px 39px;
      background: #fff;
      border-radius: 6px;

      .tab_head {
        gap: 10px 20px;
        margin-bottom: 10px;

        .tab_name {
          padding-bottom: 3px;
          font-size: 15px;
          border-bottom: solid 2px #fff;

          &.active {
            border-bottom: solid 2px @app-color;
          }

          &:hover {
            cursor: pointer;
          }
        }
      }

      .tab_content {
        gap: 10px;
      }

      .country_list {
        a {
          font-size: 15px;
          color: #333;
          min-width: 129px;
          // margin-right: 20px;
          // margin-bottom: 10px;

          &:nth-child(8n) {
            margin-right: 0;
          }
        }
      }
    }
  }

  .bottom-az {
    width: 1190px;
    display: flex;
    margin: 10px auto;
    padding-left: 14px;

    h4 {
      margin-right: 10px;
      cursor: pointer;
    }
  }
</style>
